import type { ReactNode } from 'react';
import { BRAND } from '@/config/brand';

interface AuthCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
  /** Show Fattah wordmark above the card title (default: true). */
  showLogo?: boolean;
}

export function AuthCard({ title, subtitle, children, footer, showLogo = true }: AuthCardProps) {
  return (
    <div className="animate-fade-in rounded-2xl border border-slate-200/80 bg-white/95 p-8 shadow-xl shadow-slate-200/50 backdrop-blur-sm dark:border-slate-700/80 dark:bg-slate-900/95 dark:shadow-black/30">
      {showLogo ? (
        <div className="mb-6 flex justify-center">
          <img
            src={BRAND.logoPath}
            alt={BRAND.name}
            className="h-11 w-auto max-w-[240px] object-contain sm:h-12"
            width={240}
            height={48}
          />
        </div>
      ) : null}
      {title.trim() ? (
        <h2 className="text-center text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">{title}</h2>
      ) : null}
      {subtitle ? (
        <p className="mt-1.5 text-center text-sm text-slate-500 dark:text-slate-400">{subtitle}</p>
      ) : null}
      <div className="mt-6">{children}</div>
      {footer ? <div className="mt-6 border-t border-slate-100 pt-4 dark:border-slate-800">{footer}</div> : null}
    </div>
  );
}
